import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Create root and render App without StrictMode
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
